export enum ShiftInclusion {
  /** Pouze odpracované směny. */
  Worked = "Worked",
  /** Odpracované i plánované směny. */
  PlannedAndWorked = "PlannedAndWorked",
}
